import { useState } from 'react';


import { ChevronDown } from 'lucide-react';
import { CONTACT_FAQS } from '@/data/contact';
import { getLive, useLiveTick } from '@/lib/liveContent';
import { Reveal } from '../Reveal';
import { cn } from '@/lib/utils';

// Accessible FAQ accordion — only genuine, answerable questions. FAQ
// structured data is emitted by ContactPage from this same visible list.
export const ContactFaq = () => {
  useLiveTick();
  const [open, setOpen] = useState(0);
  const live = (getLive('faqs') || []).filter((f) => f.assignedPage === 'contact');
  const faqs = live.length ? live : CONTACT_FAQS;

  return (
    <section aria-labelledby="contact-faq-heading" data-testid="contact-faq" className="bg-mist py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <div className="text-center">
          <p className="flex items-center justify-center gap-3">
            <span className="font-mono text-xs font-medium tracking-widest text-gold-700">07</span>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">FAQ</span>
          </p>
          <h2 id="contact-faq-heading" data-testid="contact-faq-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={faq.question} delay={i * 0.05}>
                <div className="rounded-xl border border-slate-200 bg-white">
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      aria-controls={`faq-panel-${i}`}
                      id={`faq-button-${i}`}
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      data-testid={`faq-toggle-${i}`}
                      className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    >
                      <span className="text-base font-bold text-navy-900">{faq.question}</span>
                      <ChevronDown
                        className={cn(
                          'h-4 w-4 shrink-0 text-gold-700 transition-transform duration-200',
                          isOpen && 'rotate-180'
                        )}
                        aria-hidden="true"
                      />
                    </button>
                  </h3>
                  <div
                    id={`faq-panel-${i}`}
                    role="region"
                    aria-labelledby={`faq-button-${i}`}
                    hidden={!isOpen}
                    data-testid={`faq-panel-${i}`}
                  >
                    <p className="px-6 pb-6 text-sm leading-relaxed text-slate-600">{faq.answer}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
